import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

import BreadCrumbs from 'components/BreadCrumbs';
import isEmpty from 'lodash.isempty';
import articleHandler from 'indefinite';
import RelatedArticles from 'components/RelatedArticles';
import RecommendedVendors from 'components/Article/RecommendedVendors';
import SectionContainer from 'components/grid/SectionContainer';
import EditorialContainer from 'components/grid/EditorialContainer';
import { HeroWithConfetti } from 'components/Hero';
import PlannerValueProposition from 'components/PlannerValueProposition';

import VendorsSearch from './VendorsSearch';
import EventBlurb from './EventBlurb';
import CreateAccount from 'components/CreateAccount';

const StyledEditorialContainer1 = styled(EditorialContainer)({
  marginTop: 4,
  marginBottom: 56,
});

const StyledEditorialContainer2 = styled(EditorialContainer)({
  margintop: 4,
  marginBottom: 32,
});

const StyledEditorialContainerLongformSeoCopy = styled(EditorialContainer)({
  marginTop: 32,
  marginBottom: 32,
});

export const EventPage = (props) => {
  const { event, featureFlags } = props;
  const { hasCreateAccount } = featureFlags;
  const {
    heroCopyH1,
    heroCopyH2,
    eventName,
    eventFileName,
    relatedArticles,
    relatedVendors,
    titleTag,
    h2Blurb1,
    blurb1,
    h2Blurb2,
    blurb2,
    longformH2,
    longformSeoCopy,
  } = event;
  const showSolidBackground = eventFileName === 'memorial-service' || eventFileName === 'funeral';
  const breadCrumbs = [
    {
      path: '/event-inspiration',
      label: 'Event Inspiration',
    },
    {
      path: '/events',
      label: 'Events',
    },
    {
      label: eventName,
    },
  ];
  const defaultHeroTitle = `Plan the perfect ${!isEmpty(eventName) ? eventName : 'event'}`;
  const defaultHeroSubtitle = 'Find and book a vendor to bring your celebration to life.';

  return (
    <>
      <SectionContainer>
        <BreadCrumbs items={breadCrumbs} />
      </SectionContainer>
      <HeroWithConfetti
        title={heroCopyH1 || defaultHeroTitle}
        subtitle={heroCopyH2 || defaultHeroSubtitle}
        solidBackground={showSolidBackground}
      />
      {hasCreateAccount && <CreateAccount />}
      <StyledEditorialContainer1 justifyContent="center">
        <EventBlurb header={h2Blurb1} blurb={blurb1} clickArea="Blurb 1" title={event.titleTag} />
      </StyledEditorialContainer1>
      <SectionContainer>
        <RecommendedVendors
          relatedVendors={relatedVendors}
          title={`Top Vendors for ${articleHandler(eventName)}`}
          clickEventProperties={{
            eventType: eventName,
            title: titleTag,
          }}
          showMore
        />
        <PlannerValueProposition />
      </SectionContainer>
      <VendorsSearch />
      <StyledEditorialContainer2 justifyContent="center">
        <EventBlurb header={h2Blurb2} blurb={blurb2} clickArea="Blurb 2" title={event.titleTag} />
      </StyledEditorialContainer2>
      <RelatedArticles
        articles={relatedArticles}
        analyticsProps={{
          eventType: eventName,
          path: `/events/${eventFileName}`,
          hasSeoCopy: !isEmpty(longformSeoCopy),
        }}
        title="Related Articles"
        titleAlign="center"
      />
      <StyledEditorialContainerLongformSeoCopy justifyContent="center">
        <EventBlurb
          header={longformH2}
          blurb={longformSeoCopy}
          clickArea="Longform SEO Copy"
          title={event.titleTag}
        />
      </StyledEditorialContainerLongformSeoCopy>
    </>
  );
};

EventPage.propTypes = {
  event: PropTypes.shape({}).isRequired,
  featureFlags: PropTypes.shape({}).isRequired,
};

export default EventPage;
